// Route tree for TanStack Router
import { createRootRoute, createRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AppShell } from './routes/__root';
import { IndexPage } from './routes/index';
import { CreatePage } from './routes/create';
import { AdminPage } from './routes/admin';
import { DemoRoute } from './routes/demo';
import { DemoSaasRoute } from './routes/demo-saas';
import { DemoMarketingRoute } from './routes/demo-marketing';
import { DemoIndieRoute } from './routes/demo-indie';
import { StorePage } from './routes/store';

// Root route - minimal, no layout wrapper
const rootRoute = createRootRoute({
  component: AppShell,
});

// Index route - smart redirect based on auth state
const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: IndexPage,
});

// Search params schema for /create route
const createSearchSchema = z.object({
  session: z.string().uuid().optional(),
  version: z.string().uuid().optional(),
});

// Create route (main generation page)
const createPageRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/create',
  component: CreatePage,
  validateSearch: (search) => createSearchSchema.parse(search),
});

// Demo route (for landing page preview embed)
const demoRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/demo',
  component: DemoRoute,
});

// Demo SaaS route (for /for/saas landing page)
const demoSaasRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/demo/saas',
  component: DemoSaasRoute,
});

// Demo Marketing route (for /for/marketing landing page)
const demoMarketingRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/demo/marketing',
  component: DemoMarketingRoute,
});

// Demo Indie route (for /for/indie landing page)
const demoIndieRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/demo/indie',
  component: DemoIndieRoute,
});

// Admin route (protected admin dashboard)
const adminRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/admin',
  component: AdminPage,
});

// Store route (user's video gallery)
const storeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/store',
  component: StorePage,
});

// Route tree
export const routeTree = rootRoute.addChildren([
  indexRoute,
  createPageRoute,
  storeRoute,
  adminRoute,
  demoRoute,
  demoSaasRoute,
  demoMarketingRoute,
  demoIndieRoute,
]);
